import USCoverage from 'products/nomad_insurance/assets/img/addons/us_coverage.svg';
import Sports from 'products/nomad_insurance/assets/img/addons/sports.svg';
import Electronics from 'products/nomad_insurance/assets/img/addons/electronics.svg';

export const ADULTHOOD_AGE = 18;
export const MAX_POLICY_DURATION_IN_DAYS = 364;
export const REFERRAL_TOKEN_KEY = 'referralToken';
export const NI_REFERRAL_CAMPAIGN_ID = 'NI_C2C';
export const NI_REACTIVATION_GIFT_CARD_CAMPAIGN_ID = 'NI_REACTIVATION_GIFT_CARD';
export const AMBASSADOR_WORKATION_GIVEAWAY_CAMPAIGN_ID = 'AMBASSADOR_WORKATION_GIVEAWAY';
export const NI_GIFT_CARD_CAMPAIGN_ID = 'NI_GIFT_CARD';
export const DEDUPE_THRESHOLD_IN_MS = 1000;

export const CONTRACT_TYPE = {
  RECURRING: 'RECURRING',
  FIXED: 'FIXED'
};

export const PAYMENT_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  RENEWAL: 'RENEWAL',
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PAUSED: 'PAUSED',
  PAYMENT_FAILED: 'PAYMENT_FAILED'
};

export const CANCELLATION_REASON = {
  MODIFY_ADDON: 'MODIFY_ADDON',
  MODIFY_GROUP_MEMBER: 'MODIFY_GROUP_MEMBER',
  WRONG_START_DATE: 'WRONG_START_DATE',
  DONT_NEED_COVERAGE: 'DONT_NEED_COVERAGE'
};

export const DISCOUNT_TYPES = {
  NI_C2C_REFERRAL: 'NI_C2C_REFERRAL',
  NI_REACTIVATION_GIFT_CARD: 'NI_REACTIVATION_GIFT_CARD',
  NI_GIFT_CARD: 'NI_GIFT_CARD'
};

export const VOUCHER_PROVIDER = {
  AIRALO: 'AIRALO'
};

export const NEST_ITEM_NAMES = {
  VETERAN: 'VETERAN',
  CONTRIBUTOR: 'CONTRIBUTOR',
  ALTRUIST: 'ALTRUIST',
  UNKNOWN: 'UNKNOWN'
};

export const FORBIDDEN_DESTINATIONS_SW = ['CU', 'IR', 'SY', 'KP', 'RU', 'BY', 'UA', 'PR'];
export const US_ADDON_REQUIRED_DESTINATIONS_SW = ['US', 'AS', 'VI', 'MP', 'GU'];

export const FORBIDDEN_DESTINATIONS_SW_FOR_US_USERS = [
  'AS',
  'VI',
  'MP',
  'GU',
  'CU',
  'IR',
  'SY',
  'KP',
  'RU',
  'BY',
  'UA',
  'US',
  'PR'
];

export const ERROR_TITLE_DEFAULT = 'Something went wrong';
export const ERROR_MESSAGE_DEFAULT =
  'How embarrassing... Something went wrong. If the problem remains, please contact our customer support.';

export const SERVER_ERRORS = {
  PURCHASE__DUPLICATE_GROUP: {
    title: 'Error',
    message:
      'An individual was added twice to a group purchase. Keep in mind the primary account holder should not be added as a group member.'
  },
  PURCHASE__DATE_OVERLAP: {
    title: 'Error',
    message:
      'The attempted purchase date overlaps with an already active insurance policy. Make sure to select a start date after the end date of your previous policy.'
  },
  EXCEPTION: {
    title: 'Error',
    message: 'How embarrassing... Something went wrong, we are aware of the issue.'
  },
  TM__INTERNAL: {
    title: 'Error',
    message: 'How embarrassing... Something went wrong, we are aware of the issue.'
  },
  TM__UNKNOWN: {
    title: 'Error',
    message: 'How embarrassing... Something went wrong, we are aware of the issue.'
  },
  TM__RESTRICTED_COUNTRY: {
    title: 'Error',
    message: 'One of the countries you want to travel to are restricted.'
  },
  TM__CREDIT_CARD_EXPIRATION: {
    title: 'Invalid expiration date',
    message: 'Please check your credit card expiration date and ensure it is correct.'
  },
  TM__CREDIT_CARD_NUMBER: {
    title: 'Error',
    message: 'Please check your credit card number and ensure it is correct.'
  },
  TM__CREDIT_CARD_RESTRICTED: {
    title: 'Error',
    message:
      'The card has been restricted. We recommend you contact the card issuer or attempt another card.'
  },
  TM__CREDIT_CARD_CCV: {
    title: 'Error',
    message: 'Please check your credit card CVV and ensure it is correct.'
  },
  TM__TRANSACTION_DECLINED: {
    title: 'Error',
    message: 'Your transaction was declined.'
  },
  AFFILIATE__FORM_ERROR: {
    title: 'Error',
    message:
      'Something went wrong with the registration. Please contact customer support.'
  },
  ITEM_COVERAGE__SHORT_COVERAGE: {
    title: 'Error',
    message:
      'The electronics theft add-on is only available for policies longer than 28 days.'
  },
  DEFAULT: {
    title: ERROR_TITLE_DEFAULT,
    message: ERROR_MESSAGE_DEFAULT
  }
};

export const PLANS = {
  STANDARD_NOMAD_INSURANCE: {
    id: 51,
    value: 'STANDARD_NOMAD_INSURANCE',
    isAddon: false
  },
  USA_COVERAGE: {
    id: 52,
    value: 'USA_COVERAGE',
    img: USCoverage,
    name: 'US coverage',
    description: 'For travel to the US and US territories.',
    tooltip:
      'Coverage that includes travel to the US and US territories. Not applicable to US citizens or residents.',
    analyticsName: 'addon_ni_usCoverage',
    isAddon: true
  },
  SPORTS_COVERAGE: {
    id: 56,
    value: 'SPORTS_COVERAGE',
    img: Sports,
    name: 'Adventure sports',
    description: 'For additional adventure sports like skydiving, hang gliding and more.',
    tooltip:
      'Coverage for additional adventure sports like cave diving, hang gliding, snow mobile, kite surfing, martial arts, skydiving. Full list of sports covered by SafetyWing Nomad Insurance with and without this add-on in our FAQ.',
    analyticsName: 'addon_ni_adventureSports',
    isAddon: true
  },
  ITEM_INSURANCE: {
    id: 53,
    value: 'ITEM_INSURANCE',
    img: Electronics,
    name: 'Electronics theft',
    description: 'For electronics up to $1,000 USD per item for policies > 28 days.',
    disabledDescription: 'Only available for recurring policies.',
    tooltip:
      'Coverage for electronics like laptops, tablets and cameras for up to $1000 per stolen item, with a total yearly limit of $3000 per policy.',
    analyticsName: 'addon_ni_itemInsurance',
    isAddon: true
  }
};
export const NI_ADDONS = Object.fromEntries(
  Object.entries(PLANS).filter(([key, value]) => value.isAddon)
);

export const PERSON_DETAILS_TYPE = {
  POLICY_HOLDER: 'PolicyHolder',
  GROUP_MEMBER: 'GroupMember'
};
